import './Login.css';
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import LandPage from '../../../Component/common/LandPage/LandPage'
import Navbar from '../../../Component/common/Navbar/Navbar'
import Topbar from '../../../Component/common/Topbar/Topbar'
import Footer from '../../../Component/common/Footer/Footer';
import base_url from '../../../config/base_url'
import axios from 'axios'
import BtnLoader from '../../../Component/common/BtnLoader/BtnLoader'
import TokenSlice from '../../../zustand/TokenSlice.js'
import UserDataSlice from '../../../zustand/UserDataSlice'
import handleApiError from '../../../utils/handleApiError'
import { sendTokenToBackend } from '../../../firebase/sendTokenToBackend';
import { getFCMToken } from '../../../firebase/getFCMToken';
import { Google } from '../../../Assets/SVGS';
function Login(){
  const { t } = useTranslation();
  const [loader , setLoader] = useState(false)
  const nav = useNavigate()
  const setToken = TokenSlice((state) => state.setToken);
  const setUserData = UserDataSlice(
    (state) => state.createUserDataSlice
  );
  const {createUserDataSlice} = UserDataSlice()
  const [data , setData] = useState({
    email : "ahmed.admin1@example.com",
    password :"12345678"
  })

  function validate_data(){
    if(!data.email  || !data.password){
      toast.warn(t('enterAllFields'))
      return
    }

    let is_match = data.email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    if (! is_match){
      toast.warn(t('validEmail'))
    }
    else if (data.password.length < 8){
      toast.warn(t('passwordLength'))
    }

  }

  const createAccount = async()=>{
    validate_data()

    try{
      setLoader(true)
      const res = await axios.post(`${base_url}/auth/login` , data)
        if(res.status){
          
          setToken(res.data.data.accessToken)
          setUserData(res.data.data.user)
          nav('/', {state:{success:true , msg:res.data.message}})

          const fcmToken = await getFCMToken();

          await sendTokenToBackend("userId", fcmToken);
        }
    }
    catch (error){
      handleApiError(error)
    }
    finally{
      setLoader(false)
    }
  }

  const handleGoogleLogin = ()=>{
    window.location.href = `${base_url}/auth/google`
  }
  
  const location = useLocation()
  useEffect(() => {
    if(location.state?.logout){
      const timeToShowToast =  setTimeout(()=>{
        toast.success(location.state?.msg)
      },1000)
      return ()=>clearTimeout(timeToShowToast)
    }
  }, [])
  
  return(
    <>
      <ToastContainer/>
      <Topbar/>
      <Navbar/>
      <LandPage header={t('login')} link={t('login')} href='/login'/>
      <div className="login-container container">
        <div className="login-content content">

          <div className="leftLogin"></div>

          <div className="rightLogin">
            
            <div className="header">
              <h2 className='h-after-effect'>{t('loginHere')}</h2>
              <p>{t('noAccount')} 
                <Link to="/sign-up">
                {t('registerHere')}
                </Link>
                </p>
            </div>

            <div className='inputs'>
                <input onChange={(e)=>setData((prev)=>({...prev , email:e.target.value}))}  value={data.email} type="email" placeholder={t('email')} />
                <input onChange={(e)=>setData((prev)=>({...prev , password:e.target.value}))}  value={data.password} type="password" autoComplete='' placeholder={t('password')} />
            
            </div>
          
            {
              loader?
                <BtnLoader/>
              :
              (
                <div style={{display:"flex",flexDirection:"column",gap:"10px"}}>
                  <button onClick={()=>createAccount()}>{t('login')}</button>
                  <button className='googleBtn' onClick={()=>handleGoogleLogin()}><Google width="60px" heigth="20px"/> </button>
                </div>
              )
            }

          </div>
        </div>
      </div>
      <Footer/>
    </>
  )
}
export default Login